export default __webpack_public_path__ + "static/media/Krystalite.8e1b8fbf.jpeg";